import { cn } from '@/lib/cn';

type SkipLinkProps = {
  /** Target element id. Must match an `id` on the page's `<main>`. */
  targetId?: string;
  className?: string;
};

export const SkipLink = ({ targetId = 'main', className }: SkipLinkProps) => (
  <a
    href={`#${targetId}`}
    className={cn(
      'sr-only focus:not-sr-only',
      'focus:fixed focus:top-2 focus:left-2 focus:z-[60]',
      'focus:rounded focus:bg-accent focus:px-3 focus:py-2',
      'focus:text-accent-foreground focus:shadow-lg',
      'focus:outline-none focus:ring-2 focus:ring-accent-foreground/40',
      className,
    )}
  >
    Skip to content
  </a>
);
